import Styled from 'styled-components';

// Off-screen text for accessible names, for when part of a name has no visible text: the row menu is named
// "More actions <template name>" by pointing aria-labelledby at one of these and at the visible name.
// The nearest positioned ancestor should be `position: relative`.
export const HiddenLabel = Styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
`;
